<template>
    
    <GmapMap :center="mapCenter" :zoom="mapZoom" map-type-id="terrain" style="height: 500px; width: 95%" class="map-container">

        <gmap-cluster v-if="mapType === 'cluster'">

            <GmapMarker :key="index" v-for="(point, index) in mapData" :position="{ lat: point.coordinates[1], lng: point.coordinates[0] }" />

        </gmap-cluster>

        <DirectionsRenderer :data='heatmapPoints' v-show="heatmapPoints && mapType === 'heatmap'" > </DirectionsRenderer>

    </GmapMap>

</template>

<script>

import DirectionsRenderer from '../../../heatmap.js'
import { gmapApi } from 'vue2-google-maps'

export default {

    name: 'MapCluster',

    components: { DirectionsRenderer },

    data() {
        return {

            mapCenter: { lat: -17.576493, lng: -48.527000 },

            mapZoom: 4,

            heatmapDataFiltered: []

        }
    },

    computed: {

        google: gmapApi,

        heatmapPoints() {
            return this.heatmapDataFiltered
        },

    },

    props: ['mapData', 'heatData', 'mapType'],

    methods: {

    },

    mounted() {

        setTimeout(() => {

             this.heatmapDataFiltered = this.heatData.map(
            point => new google.maps.LatLng(point.lat, point.lng)
        )
            
        }, 3000);

       

    }

}

</script>

<style scoped>

.map-container {

    border-style: solid;
    border-color: #3fbdbd;
    border-radius: 5px !important;

}

</style>